import LargeModal from "components/elements/LargeModal";
import dataProvider from "core/DataProvider";
import utility from "core/Utils";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const customDateFormat = date => {
  let returnDate = date;

  if (typeof returnDate === "string") {
    try {
      returnDate = new Date(returnDate);
    } catch (error) {
      console.warn(`Invalid date passed to formatDate`);
      return returnDate;
    }
  }

  try {
    returnDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
    }).format(returnDate);
  } catch (error) {
    console.warn(`Invalid date passed to formatDate`);
  }

  return returnDate;
};

const BillingAdjustment = props => {
  const [billRows, setBillRows] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log({ props });

  const handleAdjustment = (index, value) => {
    let rows = [...billRows];
    rows[index].adjustment = value;
    setBillRows(rows);
  };

  const save = async () => {

//  console.log('ckl log row',billRows);
    const data = {
      bill_id: props.data.id,
      adjustments: billRows
        .filter(x => parseInt(x.adjustment) > 0)
        .map(x => ({ id: x.id, adjustment: parseInt(x.adjustment) })),
    };


   const bill_arry = billRows.reduce((acc, item) => {
  acc[item.id] = item.count;
  return acc;
}, {});

const adjustmentMap = Object.fromEntries(data.adjustments.map(item => [item.id, item.adjustment]));

const finalArray = Object.entries(bill_arry).map(([key, value]) =>
  adjustmentMap[key] !== undefined ? adjustmentMap[key] : value
);

const totalsum = finalArray.reduce((acc, val) => acc + val, 0);

if (Number(totalsum) > Number(props.data.allocated_spots)) {
    toast.error("Total bill spots cannot exceed allocated spots.");
    return;
  }
  setLoading(true);
    try {
      await dataProvider.network.post("billing/save-adjustment", data);
      toast.success("Adjustment saved successfully");
      props.onClose();
    } catch (error) {
      console.error(error);
      const message =
      error?.response?.data?.message || // Most backends send error in `message`
      error?.response?.data?.error ||   // Or sometimes under `error`
      "Failed to save adjustment";
    //  toast.error("Failed to save adjustment");
    toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillRows = async () => {
    try {
      const data = await dataProvider.network.get(
        "billing/details/" +
          props.data.id +
          "/" +
          utility.formatDateForInput(props.data.billing_month)
      );
      setBillRows(data.map(x => ({ ...x, adjustment: 0 })));
    } catch (error) {
      console.error({ error });
      toast.error("Failed to load billing details");
    }
  };

  useEffect(() => {
    fetchBillRows();
  }, []);

  return (
    <div className="billing-adjustment">
      <LargeModal onClose={() => props.onClose()}>
        <div className="flex flex-v-center" style={{ marginBottom: "1rem" }}>
          <h2>Billing Finalization</h2>
          <div className="el right">
            {loading ? (
              <div className="loader">
                <div className="lds-hourglass"></div>
              </div>
            ) : (
              <button onClick={save}>Save & Finalize</button>
            )}
          </div>
        </div>
        <h3 style={{ marginBottom: "1rem" }}>
          {props.data.group_name} ( {props.data.allocated_spots} ) ({customDateFormat(props.data.billing_month)})
        </h3>
        <div className="adjustment">
          <div className="header-row flex">
            <div className="col">Advertiser</div>
            <div className="col">Brand</div>
            <div className="col">Count</div>
            <div className="col">Final Count</div>
          </div>
          <div className="adjustment-body">
            {billRows.map((row, index) => (
              <div className="row" key={index}>
                <div className="col">{row.advertiser}</div>
                <div className="col">{row.brand}</div>
                <div className="col">{row.count}</div>
                <div className="col">
                  <input
                    type="text"
                    value={row.adjustment}
                    onChange={e => handleAdjustment(index, e.target.value)}
                    placeholder="Adjustment"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </LargeModal>
    </div>
  );
};

export default BillingAdjustment;
